import { createEntityAdapter, EntityState } from "@reduxjs/toolkit";
import { Benefit_Entity } from "../../entities/benefit";
import { filmsApi } from "../api/filmsApi";

const benefitsAdapter = createEntityAdapter<Benefit_Entity>();
const initialState = benefitsAdapter.getInitialState();

export const benefitEndpoints = filmsApi.injectEndpoints({
  endpoints: (build) => ({
    getBenefits: build.query<EntityState<Benefit_Entity>, void>({
      query: () => `benefits`,
      transformResponse: (responseData: Benefit_Entity[]) => {
        return benefitsAdapter.setAll(initialState, responseData);
      },
      providesTags: ["benefits"],
    }),
    getBenefit: build.query<Benefit_Entity, number>({
      query: (id) => `benefits/${id}`,
      providesTags: (result, error, id) => [{ type: "benefits", id }],
    }),
    getBenefitSearchMetadata: build.query<any, void>({
      query: (id) => `benefits/searchMetadata`,
    }),
    createBenefit: build.mutation<Benefit_Entity, Partial<Benefit_Entity>>({
      query: (body) => ({
        method: "POST",
        body,
        url: `benefits`,
      }),
      invalidatesTags: ["benefits"],
    }),
    updateBenefit: build.mutation<
      void,
      { id: number; body: Partial<Benefit_Entity> }
    >({
      query: (args) => ({
        method: "PUT",
        body: args.body,
        url: `benefits/${args.id}`,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "benefits", id },
        "benefits",
      ],
    }),
    deleteBenefit: build.mutation<void, number>({
      query: (id) => ({
        method: "DELETE",
        url: `benefits/${id}`,
      }),
      invalidatesTags: ["benefits"],
    }),
  }),
});

export const {
  useGetBenefitSearchMetadataQuery,
  useGetBenefitQuery,
  useGetBenefitsQuery,
  useCreateBenefitMutation,
  useDeleteBenefitMutation,
  useUpdateBenefitMutation,
} = benefitEndpoints;

export default benefitEndpoints;
